<template>
  <div
    style="width: 100%; height: 100%"
    ref="map"
    class="mapBox"
  ></div>
</template>

<script>
export default {
  props: {
    center: {
      type: Array,
      default: [],
    },
    zoom: {
      type: Number,
      default: 14,
    },
    pitch: {
      type: Number,
      default: 45,
    },
    rotation: {
      type: Number,
      default: 0,
    },
    mapStyleId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    init() {
      var center = new TMap.LatLng(...this.center);
      var map = new TMap.Map(this.$refs.map, {
        center: center, //设置地图中心点坐标
        zoom: this.zoom, //设置地图缩放级别
        pitch: this.pitch, //设置俯仰角
        rotation: this.rotation, //设置地图旋转角度
        mapStyleId: this.mapStyleId,
      });
      document.querySelector(".mapBox div").remove();
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {},
  watch: {
    option: {
      //   handler(n, o) {
      //     if (this.chart) {
      //       this.chart.setOption(this.option);
      //     }
      //   },
    },
  },
};
</script>
<style scoped lang="scss">
</style>